import { endpoints } from 'api/endpoints'
import { GetAllData, GetAllResponse, GetOneResponse, Pagination } from 'interfaces/api.interfaces'
import { Group, GroupBase, Permission, UpdatePermissionsGroup } from 'interfaces/api/groups.interfaces'
import { axios } from 'modules/axios'
import { defaultPagination, withoutPagination } from 'utils/pagination'

const getAll = async (params?: Partial<Pagination>): GetAllResponse<Group> => {
  const { data: response } = await axios.request<GetAllData<Group>>({
    method: 'GET',
    url: endpoints.groups.getAll(),
    params: {
      ...withoutPagination(params),
      ...defaultPagination(params),
    },
  })
  return response
}

const getSingle = async (id: number): GetOneResponse<Group> => {
  const { data: response } = await axios.request<Group>({
    method: 'GET',
    url: endpoints.groups.getSingle(id),
  })
  return response
}

const create = async (data: GroupBase): GetOneResponse<Group> => {
  const { data: response } = await axios.request<Group>({
    method: 'POST',
    url: endpoints.groups.create(),
    data,
  })
  return response
}

const update = async (id: number, data: GroupBase): GetOneResponse<Group> => {
  const { data: response } = await axios.request<Group>({
    method: 'PATCH',
    url: endpoints.groups.update(id),
    data,
  })
  return response
}

const remove = async (id: number): Promise<void> =>
  axios.request({
    method: 'DELETE',
    url: endpoints.groups.remove(id),
  })

const getAllPermissions = async (pagination?: Pagination): GetAllResponse<Permission> => {
  const { data: response } = await axios.request<GetAllData<Permission>>({
    method: 'GET',
    url: endpoints.groups.getAllPermissions(),
    params: defaultPagination(pagination),
  })
  return response
}

const getGroupPermissions = async (groupId: number, pagination?: Pagination): GetAllResponse<Permission> => {
  const { data: response } = await axios.request<GetAllData<Permission>>({
    method: 'GET',
    url: endpoints.groups.getGroupPermissions(groupId),
    params: defaultPagination(pagination),
  })
  return response
}

const updateGroupPermissions = async (groupId: number, data: UpdatePermissionsGroup): Promise<void> => {
  await axios.request({
    method: 'POST',
    url: endpoints.groups.updateGroupPermissions(groupId),
    data,
  })
}

export const groupsApi = {
  getAll,
  getSingle,
  create,
  update,
  remove,
  getAllPermissions,
  getGroupPermissions,
  updateGroupPermissions,
}
